export default __webpack_public_path__ + "static/media/elephant-2.b001b8bc.png";